<template>
  <Dialog
    :visible="dialogVisible"
    title="自定义显示列"
    @close="handleClose"
    width="600px"
  >
    <div
      v-for="(item, index) in dataSource"
      :key="index"
      class="custom-group"
    >
      <!-- 全选按钮 -->
      <Checkbox
        v-model="item.isCheckAll"
        :indeterminate="item.isIndeterminate"
        @change="handleCheckBoxAllChange($event, item)"
      >
        <span class="custom-title">{{ item.name }}</span>
      </Checkbox>

      <div style="margin: 20px 0;" />

      <!-- 单个自定义列选项 -->
      <Checkbox
        v-for="col in item.children"
        :key="col.key"
        v-model="col.isSelected"
        class="custom-checkbox"
        :label="col.key"
        @change="handleCheckBoxChange($event, col, item)"
      >
        {{ col.name }}
      </Checkbox>
    </div>

    <span
      slot="footer"
      class="custom-footer"
    >
      <Button
        type="primary"
        @click="handleConfirm"
      >
        确定
      </Button>
      <Button @click="handleClose">取消</Button>
    </span>
  </Dialog>
</template>

<script>
import { Dialog, Checkbox, Button } from 'element-ui';

import { targetFieldsList } from '../config/';
import { compose } from '../config/group';
import { arrToTree } from '../util';

export default {
  name: 'customColumn',
  components: {
    Dialog,
    Checkbox,
    // CheckboxGroup,
    Button,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    defaultData: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      dialogVisible: this.visible,
      dataSource: this.initData(targetFieldsList),
    };
  },

  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
    },
  },

  methods: {
    initData(data) {
      const tree = arrToTree(targetFieldsList);
      const list = compose(tree);

      const selected = this.defaultData.reduce((prev, current) => {
        prev.push(current.key);
        return prev;
      }, []);

      const $this = this;
      return list.map((col) => {
        const _children = col.children.map((c) => {
          const bool = selected.includes(c.key);
          $this.$set(c, 'isSelected', bool);
          return c;
        });
        const temp = _children.filter((i) => i.isSelected);
        // 是否选中部分
        $this.$set(
          col,
          'isIndeterminate',
          temp.length > 0 && temp.length < col.children.length,
        );
        // 是否选中全部
        $this.$set(
          col,
          'isCheckAll',
          temp.length === col.children.length && temp.length !== 0,
        );
        // 初始化列
        col.children = _children;
        return col;
      });
    },

    // 全选按钮
    handleCheckBoxAllChange(val, item) {
      // const $this = this;
      const temp = item.children.map((col) => {
        col.isSelected = val;
        return col;
      });
      this.$set(item, 'children', temp);
    },

    // 单个项变化
    handleCheckBoxChange(val, col, parent) {
      col.isSelected = val;
      const selected = this.getSelected(parent.children);
      parent.isIndeterminate =
        selected.length > 0 && selected.length < parent.children.length;
      parent.isCheckAll = selected.length === parent.children.length;
    },

    // 获取所有被选中的项
    getSelected(list) {
      return list.filter((item) => item.isSelected);
    },

    handleClose() {
      this.dialogVisible = false;
      this.$emit('update:visible', false);
    },

    handleConfirm() {
      const keys = [];
      const temp = this.dataSource.reduce((accumulator, currentValue) => {
        return accumulator.concat(currentValue.children);
      }, []);
      const columns = temp.filter((item) => {
        if (item.isSelected) {
          keys.push(item.key);
        }
        return item.isSelected;
      });

      this.$emit('confirm', { columns, keys });
      this.handleClose();
    },
  },
};
</script>

<style lang="less" scoped>
.custom {
  &-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }

  &-group {
    margin-bottom: 32px;
  }

  &-checkbox {
    margin-bottom: 20px;
  }

  &-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
